import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { appBootstrap } from '@unpispas/upp-base';
import { languageService, languageSupport } from '@unpispas/upp-base';
import { viewService } from '@unpispas/upp-base';
import { loginService } from '@unpispas/upp-data';

/********************************/
/* Guest access status          */
/********************************/

type GuestAccessStatus = 'LOADING' | 'ERROR' | 'READY';

/** Guest QR entry: session via {@link loginService.DoAccess}. */
@Component({
    selector: 'upp-guest-access',
    templateUrl: './upp-access.html',
    styleUrls: ['./upp-access.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UppGuestAccessComponent extends languageSupport implements OnInit {
    /********************************/
    /* Status                       */
    /********************************/

    status: GuestAccessStatus = 'LOADING';

    private _readyMarked = false;

    constructor(
        private route: ActivatedRoute,
        private login: loginService,
        private lang: languageService,
        private change: ChangeDetectorRef,
        public view: viewService,
    ) {
        super(lang, change);
    }

    /********************************/
    /* Lifecycle                    */
    /********************************/

    async ngOnInit(): Promise<void> {
        try {
            const _params = this.route.snapshot.queryParamMap;
            const _table = _params.get('table') || '';
            const _auth = _params.get('validQR') || '';
            const _token = _params.get('token') || '';

            const _hasTableAuth = !!(_table && _auth);
            const _hasToken = !!_token;
            if (!_hasTableAuth && !_hasToken) {
                this.status = 'ERROR';
                return;
            }

            const _ok = await this.login.DoAccess(_table, _auth, _token);
            this.status = _ok ? 'READY' : 'ERROR';
        }
        catch {
            this.status = 'ERROR';
        }
        finally {
            this.change.markForCheck();
            this._MarkSplashReady();
        }
    }

    /********************************/
    /* Private                      */
    /********************************/

    private _MarkSplashReady(): void {
        if (this._readyMarked) {
            return;
        }
        this._readyMarked = true;
        appBootstrap.MarkReady();
    }
}
